import { useStore } from '@/stores'
import { useTaxonomyStore } from '@/stores/taxonomyStore'
import { INSIGHT_TYPES } from './insightTypes'

/**
 * TEMPORARY, binder-gated "Insight Type" tag pills (Jazz Neuroscience).
 *
 * Independent multi-select tagging shown directly under Key Insight Topics.
 * Renders only when the feature flag is on for the user's binder AND an
 * indication has been selected (same trigger as KIT). Selections are plain
 * label strings stored on the submission as `insightTags`.
 */
export function InsightTypePills() {
  const insightTypesEnabled = useTaxonomyStore(
    (state) => state.data?.insightTypesEnabled ?? false,
  )
  const selectedIndicationId = useStore((state) => state.selectedIndicationId)
  const selectedInsightTags = useStore((state) => state.selectedInsightTags)
  const toggleInsightTag = useStore((state) => state.toggleInsightTag)

  if (!insightTypesEnabled || !selectedIndicationId) {
    return null
  }

  const selected = new Set(selectedInsightTags)

  return (
    <div>
      <p className="mb-2.5 text-sm font-medium text-gray-300">Insight Type</p>
      <div className="flex flex-wrap gap-2.5" role="group" aria-label="Insight Type">
        {INSIGHT_TYPES.map((label) => {
          const isSelected = selected.has(label)
          return (
            <button
              key={label}
              type="button"
              onClick={() => toggleInsightTag(label)}
              aria-pressed={isSelected}
              className={`rounded-full px-4 py-2 text-sm font-semibold transition-all duration-150 focus:outline-none focus:ring-2 focus:ring-neon-cyan/60 focus:ring-offset-2 focus:ring-offset-navy ${
                isSelected
                  ? 'bg-neon-cyan text-navy shadow-sm'
                  : 'bg-navy-light text-[#7cb0e8] hover:bg-navy-light/80 hover:text-[#a9cef5]'
              }`}
            >
              {label}
            </button>
          )
        })}
      </div>
    </div>
  )
}
